import { TrackableType } from "@redotech/redo-model/trackable";
import * as z from "zod/v4";

const BaseResendEmailInputSchema = z.object({
  emailURL: z.string(),
  templateId: z.string().nullish(),
});

const ResendFulfillmentGroupEmailInputSchema =
  BaseResendEmailInputSchema.extend({
    fulfillmentGroupId: z.string(),
    trackableType: z.literal(TrackableType.FULFILLMENT_GROUP),
  });

const ResendOrderEmailInputSchema = BaseResendEmailInputSchema.extend({
  orderId: z.string(),
  trackableType: z.literal(TrackableType.ORDER),
});

const ResendReturnEmailInputSchema = BaseResendEmailInputSchema.extend({
  returnId: z.string(),
  trackableType: z.literal(TrackableType.RETURN),
});

export const ResendEmailInputSchema = z.union([
  ResendFulfillmentGroupEmailInputSchema,
  ResendOrderEmailInputSchema,
  ResendReturnEmailInputSchema,
]);

export type ResendEmailInput = z.infer<typeof ResendEmailInputSchema>;

export const resendEmail = {
  name: "resendEmail" as const,
  input: ResendEmailInputSchema,
  output: z.literal("success"),
};
